module.exports = __webpack_public_path__ + "static/media/seats_faded@lowrez.06f87163.jpg";